import { chatWebSocketService } from "./useChatWebSocket";

export const restoreStoredChatSession = ({
  setCurrentSession,
  setIsUserInfoSubmitted,
}) => {
  const existingSessionId = localStorage.getItem("chat_session_id");
  const existingSessionData = localStorage.getItem("chat_session_data");

  if (!existingSessionId || !existingSessionData) {
    return;
  }

  try {
    const sessionData = JSON.parse(existingSessionData);
    if (sessionData?.session_id) {
      setCurrentSession(sessionData);
      setIsUserInfoSubmitted(true);
    }
  } catch (error) {
    console.error("Failed to restore existing chat session:", error);
  }
};

export const connectChatSessionWebSocket = async ({
  sessionId,
  connectWebSocketRef,
  connectingRef,
  connectedSessionIdRef,
}) => {
  if (connectingRef.current) {
    return;
  }

  connectingRef.current = true;
  connectedSessionIdRef.current = sessionId;

  try {
    const testResult = await chatWebSocketService.testConnection(sessionId);
    if (testResult.success && connectWebSocketRef.current) {
      await connectWebSocketRef.current(sessionId);
      return;
    }
  } catch (error) {
    console.error("Failed to connect WebSocket:", error);
  }

  setTimeout(() => {
    connectingRef.current = false;
    if (connectedSessionIdRef.current === sessionId) {
      connectedSessionIdRef.current = null;
    }
  }, 1000);
};

export const initializeLoggedInChatSession = async ({
  loggedInUser,
  initializeChatSessionMutation,
  setCurrentSession,
  setIsUserInfoSubmitted,
  setIsInitializing,
  resetSessionClearedFlag,
  connectingRef,
  connectedSessionIdRef,
}) => {
  resetSessionClearedFlag();
  connectingRef.current = false;
  connectedSessionIdRef.current = null;

  const userEmail = loggedInUser?.email;
  const userFirstName = loggedInUser?.first_name;
  const userLastName = loggedInUser?.last_name;
  const userName = userFirstName
    ? `${userFirstName} ${userLastName || ""}`.trim()
    : null;

  if (!userEmail || !userName) {
    return;
  }

  setIsInitializing(true);

  try {
    const response = await initializeChatSessionMutation.mutateAsync({
      customer_name: userName,
      customer_email: userEmail,
      chat_type: "Help & Feedback",
    });

    if (response.success && response.data) {
      setCurrentSession(response.data);
      setIsUserInfoSubmitted(true);
    }
  } finally {
    setIsInitializing(false);
  }
};
